import React from "react";
import BaseChart from "./BaseChart";
import APILXD from "../../../../http/APILXD";
import {message} from "antd";
import HttpTool from "../../../../tool/HttpTool";

export default class ChartForFreeSizeMsg extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartConfig: {}
    }
  }

  getData(pageParams){
    HttpTool.post(APILXD.getDeviceFreeSizeTwo, (code, msg, json) => {
      this.renderChart(json)
    }, (code, msg) => {
      message.error(msg);
    }, pageParams)
  }

  renderChart(data) {
    let newConfig = _.cloneDeep(this.state.chartConfig);

    let seriesData = [];
    data.forEach(d => {
      seriesData.push({
        name: d._id,
        value: d.count,
      })
    })

    newConfig.series = [
      {
        type: 'pie',
        radius: ['0%', '50%'],
        label:{
          formatter: `{b}\n{c}个 ({d}%)`,
        },
        data: seriesData
      },
    ];
    newConfig.dataset = {
      dimensions: ['name', 'value'],
      source: data,
    };
    newConfig.tooltip = {
      trigger: 'item',
      formatter: '{b} : {c}个 ({d}%)'
    };

    this.setState({chartConfig: newConfig});
  }

  render() {
    return <BaseChart
      chartType={"pie"}
      chartConfig={this.state.chartConfig}
    />
  }
}